import { useCallback, useState } from 'react'
import { createProject } from 'src/redux/slices/user/endpoints'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import {
  Button,
  Fade,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import CancelIcon from '@material-ui/icons/Cancel'

type ProjectCreatorProps = {
  toggleCreatingProject: () => void
}
///// Component
const ProjectCreator: React.FC<ProjectCreatorProps> = ({ toggleCreatingProject }) => {
  const [trigger, { data, isLoading }] = createProject.useMutation()
  const [projectName, setProjectName] = useState('')
  const handleProjectName = useCallback(
    (e: TextFieldOnChangeEvent) => setProjectName(e.target.value),
    [],
  )
  const create = useCallback(() => {
    trigger({ title: projectName })
    toggleCreatingProject()
  }, [trigger, projectName, toggleCreatingProject])

  return (
    <Fade in={true} timeout={500}>
      <Grid container alignItems='center' spacing={2}>
        <Grid item>
          <TextField
            helperText='Enter project name'
            label='Project Name'
            value={projectName}
            onChange={handleProjectName}
          />
        </Grid>
        <Grid item>
          <Button variant='outlined' onClick={create}>
            Create
          </Button>
        </Grid>
        <Grid item>
          <IconButton onClick={toggleCreatingProject}>
            <CancelIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Fade>
  )
}

export default ProjectCreator
